import clientSettings from './client-settings.json';
export const _clientSettings = clientSettings.config;